import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { BrandMark } from './BrandMark';
type PartnerPhotoProps = {
  name: string;
  initials: string;
  image: string;
  imageAlt: string;
  imagePosition: string;
  imageZoom: number;
  delay?: number;
};
const ease = [0.23, 1, 0.32, 1] as const;

/**
 * Executive portrait frame: navy offset panel for depth, soft shadow,
 * a champagne-gold hairline that draws in after the photo appears,
 * and a gentle zoom on hover (pointer devices only).
 */
export function PartnerPhoto({
  name,
  initials,
  image,
  imageAlt,
  imagePosition,
  imageZoom,
  delay = 0
}: PartnerPhotoProps) {
  const reduce = useReducedMotion();
  return <div className="group relative pb-3 pr-3" data-id="element-241" data-mp="z1buayj3neou">
      {/* Navy depth panel */}
      <motion.div aria-hidden="true" className="absolute bottom-0 right-0 h-[calc(100%-12px)] w-[calc(100%-12px)] bg-navy" initial={reduce ? false : {
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      margin: '0px 0px -80px 0px'
    }} transition={{
      duration: 0.3,
      delay: delay + 0.1,
      ease
    }} data-id="element-242" data-mp="34ua6mteu18np" />

      <motion.div className="relative aspect-[4/5] overflow-hidden bg-navy shadow-[0_18px_40px_-20px_rgba(11,24,48,0.55)]" initial={reduce ? false : {
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '0px 0px -80px 0px'
    }} transition={{
      duration: 0.3,
      delay,
      ease
    }} data-id="element-243" data-mp="3cc23rb59ocer">
        {image ? <div className="h-full w-full transition-transform duration-300 ease-out motion-reduce:transition-none [@media(hover:hover)]:group-hover:scale-[1.035] motion-reduce:[@media(hover:hover)]:group-hover:scale-100" data-id="element-244" data-mp="3v0yz7icehayk">
            <img src={image} alt={imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
          objectPosition: imagePosition,
          transform: `scale(${imageZoom})`,
          transformOrigin: imagePosition
        }} data-id="element-245" data-mp="8uahmddtamoh" />
          </div> : <div role="img" aria-label={`Photo of ${name} coming soon`} className="flex h-full w-full flex-col items-center justify-center text-white" data-id="element-246" data-mp="1ym8eg6csr2qr">
            <BrandMark size={44} data-id="element-247" data-mp="27mwsv263r546" />
            <span className="mt-6 font-serif text-5xl font-medium text-gold" data-id="element-248" data-mp="2lk3agtf3axrt">{initials}</span>
          </div>}

        {/* Champagne-gold hairline, inset so it sits over the photo edge */}
        <motion.span aria-hidden="true" className="pointer-events-none absolute inset-3 border border-gold/70 transition-colors duration-300 ease-out [@media(hover:hover)]:group-hover:border-gold" initial={reduce ? false : {
        opacity: 0,
        scale: 1.03
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '0px 0px -80px 0px'
      }} transition={{
        duration: 0.3,
        delay: delay + 0.2,
        ease
      }} data-id="element-249" data-mp="2vaxzu6nmudhh" />
      </motion.div>
    </div>;
}